//fixed items
//what are the events? same 50 events
//what stuff do want to infer? same 30-50 attributes about the user
// proccessor dependent on what infer wants

import { ScoringHandler } from "../scoring";
import type { EventPayloads } from "../types";
import { ViewTimeInference } from "../view-time";

export class EventProcessor {
  static handle(event: EventPayloads[keyof EventPayloads]) {
    switch (event.event) {
      case "view_product":
        EventProcessor.handleProductView(event);
        return;
      case "view_section":
        EventProcessor.handleSectionView(event);
        return;
      case "click_section":
        ScoringHandler.Section.scoreFromInteraction(event.section.id, {
          interaction: "click",
        });

        return;
    }
  }

  static handleStartIntersecting(sectionId: string, time: number) {
    ViewTimeInference.viewingCurrently = [
      ...ViewTimeInference.viewingCurrently,
      sectionId,
    ];

    ViewTimeInference.lastViewTime[sectionId] = time;
  }

  static handleProductView(
    event: Omit<EventPayloads["view_product"], "total_viewed_items">,
  ) {
    event.view_time =
      event.view_time - ViewTimeInference.lastViewTime[event.product.handle];

    ViewTimeInference.track({
      ...event,
      total_viewed_items:
        Object.keys(ViewTimeInference.sectionScore).length + 1,
      sectionsInView: ViewTimeInference.viewingCurrently.length,
    });
  }
  static handleSectionView(
    event: Omit<EventPayloads["view_section"], "total_viewed_items">,
  ) {
    event.view_time =
      event.view_time - ViewTimeInference.lastViewTime[event.section.id];

    ViewTimeInference.track({
      ...event,
      total_viewed_items:
        Object.keys(ViewTimeInference.sectionScore).length + 1,
      sectionsInView: ViewTimeInference.viewingCurrently.length,
    });
  }

  static async processProductEvent(props: ProductEvent) {
    if (props.data.type === "view") {
      const tags = await window.helium.datastore.getTags({
        id: props.product.id,
      });
    }
  }
  static processUIEvent(props: ProductEvent) {}
  static processGlobalEvent(props: ProductEvent) {}
  private static updateProductTagsPoints;
}
